export default "__VITE_PUBLIC_ASSET__2610c190__"